var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "change-class" }, [
    _c(
      "div",
      { staticClass: "ev-page-return" },
      [
        _c(
          "router-link",
          {
            attrs: { to: { path: "setting?target=" + _vm.$route.query.target } }
          },
          [_c("span", { staticClass: "el-icon-arrow-left" }), _vm._v("返回 ")]
        ),
        _vm._v(" "),
        _c(
          "el-button",
          {
            staticStyle: { float: "right", margin: "8px 10px 0 0" },
            attrs: { type: "primary", size: "small" },
            on: {
              click: function($event) {
                _vm.$router.push({
                  path: "/batchChangeClass",
                  query: {
                    target: "student",
                    gradeList: JSON.stringify(_vm.gradeList)
                  }
                })
              }
            }
          },
          [_vm._v("批量转班")]
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "change-box" },
      [
        _c(
          "el-form",
          {
            ref: "ruleForm",
            staticClass: "myform_inline",
            attrs: {
              model: _vm.ruleForm,
              rules: _vm.formInline,
              inline: true,
              "label-width": "70px"
            }
          },
          [
            _c(
              "el-form-item",
              { attrs: { label: "转出年级：", prop: "nation" } },
              [
                _c(
                  "el-select",
                  {
                    attrs: { filterable: "", placeholder: "请选择年级" },
                    on: { change: _vm.changeGrade1 },
                    model: {
                      value: _vm.ruleForm.changeFromGrade,
                      callback: function($$v) {
                        _vm.$set(_vm.ruleForm, "changeFromGrade", $$v)
                      },
                      expression: "ruleForm.changeFromGrade"
                    }
                  },
                  _vm._l(_vm.gradeList, function(item) {
                    return _c("el-option", {
                      key: item.id,
                      attrs: { label: item.name, value: item.id }
                    })
                  }),
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              { attrs: { label: "转出班级：", prop: "nation" } },
              [
                _c(
                  "el-select",
                  {
                    attrs: { filterable: "", placeholder: "请选择班级" },
                    on: { change: _vm.changeClass1 },
                    model: {
                      value: _vm.ruleForm.changeFromClass,
                      callback: function($$v) {
                        _vm.$set(_vm.ruleForm, "changeFromClass", $$v)
                      },
                      expression: "ruleForm.changeFromClass"
                    }
                  },
                  _vm._l(_vm.classList1, function(item) {
                    return _c("el-option", {
                      key: item.id,
                      attrs: { label: item.name, value: item.id }
                    })
                  }),
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              {
                staticClass: "into-grade",
                attrs: { label: "转入年级：", prop: "isOnlyChild" }
              },
              [
                _c(
                  "el-select",
                  {
                    attrs: { filterable: "", placeholder: "请选择是转入年级" },
                    on: { change: _vm.changeGrade2 },
                    model: {
                      value: _vm.ruleForm.changeToGrade,
                      callback: function($$v) {
                        _vm.$set(_vm.ruleForm, "changeToGrade", $$v)
                      },
                      expression: "ruleForm.changeToGrade"
                    }
                  },
                  _vm._l(_vm.gradeList, function(item) {
                    return _c("el-option", {
                      key: item.id,
                      attrs: { label: item.name, value: item.id }
                    })
                  }),
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              {
                staticClass: "into-class",
                attrs: { label: "转入班级：", prop: "isResidence" }
              },
              [
                _c(
                  "el-select",
                  {
                    attrs: { filterable: "", placeholder: "请选择转入班级" },
                    model: {
                      value: _vm.ruleForm.changeToClass,
                      callback: function($$v) {
                        _vm.$set(_vm.ruleForm, "changeToClass", $$v)
                      },
                      expression: "ruleForm.changeToClass"
                    }
                  },
                  _vm._l(_vm.classList2, function(item) {
                    return _c("el-option", {
                      key: item.id,
                      attrs: { label: item.name, value: item.id }
                    })
                  }),
                  1
                )
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c("shuttle", {
          ref: "shuttle",
          attrs: {
            roleList: _vm.roleList,
            shuttleTitle: _vm.shuttleTitle,
            holderName: _vm.holderName
          },
          on: { roleChange: _vm.roleChangeFn }
        }),
        _vm._v(" "),
        _c(
          "div",
          [
            _c(
              "el-button",
              {
                staticClass: "save-btn",
                attrs: { type: "default" },
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    return _vm.saveInfo($event)
                  }
                }
              },
              [_vm._v("保存")]
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }